import { Breadcrumb, Card } from "antd";
import { ReactComponent as TitleIcon } from "../../assests/images/settingsBreadCum.svg";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import AuthService from "../../services/auth.service";
import { useCallback, useEffect, useState } from "react";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function TermsAndConditionComponent() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [terms, setTerms] = useState("");

  useEffect(() => {
    termsAndConditions();
  }, []);

  const termsAndConditions = useCallback(async () => {
    try {
      const response = await AuthService.getTermsAndConditions();
      if (response.status === 200) {
        setTerms(response.data.url);
      }
    } catch (err) {}
  }, []);

  const uploadPad = (
    <div>
      {terms ? (
        <iframe
          title={t("navigation.pdf_preview", {
            defaultValue: "PDF Preview",
          })}
          src={terms}
          width={"100%"}
          height={530}
          className="pdfview"
          allowfullscreen
          sandbox
        />
      ) : (
        <p>{t("pages.login.loading", { defaultValue: "Loading" })} ...</p>
      )}
    </div>
  );

  return (
    <div>
        <Breadcrumb separator=">" className="hide-xs">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.terms_condition", {
                defaultValue: "Terms And Conditions",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.terms_condition", {
                defaultValue: "Terms And Conditions",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div>{uploadPad}</div>
    </div>
  );
}
